/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeeContractCreateApiModel } from './employeeContractCreateApiModel';
import { AddressApiModel } from './addressApiModel';


export interface CreateEmployeeApiModel { 
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    dateOfBirth: string;
    email?: string | null;
    phoneNumber?: string | null;
    personalNumber?: string | null;
    birthNumber?: string | null;
    active?: boolean | null;
    contracts: Array<EmployeeContractCreateApiModel>;
    addressDto: AddressApiModel;
}

